import { t } from '@lingui/macro'
import React from 'react'

import { i18n } from '../i18n'
import { GuestLayout } from '../organisms/GuestLayout'

export const NotFoundPage: React.SFC = () => (
  <GuestLayout title={i18n._(t`Nenalezeno`)}>
    <h1>{i18n._(t`Nic tady není, je nám líto.`)}</h1>
  </GuestLayout>
)
